/* ============================================================
   Peak Mito Theme JS
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {

  /* --- Header scroll shadow --- */
  const header = document.querySelector('.site-header');
  if (header) {
    const onScroll = () => header.classList.toggle('scrolled', window.scrollY > 8);
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* --- Mobile menu toggle --- */
  const menuToggle = document.querySelector('.menu-toggle');
  const navRow     = document.querySelector('.site-header__nav-row');
  if (menuToggle && navRow) {
    menuToggle.addEventListener('click', function () {
      const isOpen = navRow.classList.toggle('mobile-open');
      menuToggle.classList.toggle('active', isOpen);
      menuToggle.setAttribute('aria-expanded', isOpen);
    });
    // Close on nav link click
    navRow.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', () => {
        navRow.classList.remove('mobile-open');
        menuToggle.classList.remove('active');
        menuToggle.setAttribute('aria-expanded', 'false');
      });
    });
  }

  /* --- Quantity selector --- */
  document.querySelectorAll('.quantity-selector').forEach(function (selector) {
    const input    = selector.querySelector('.qty-input');
    const minusBtn = selector.querySelector('[data-action="minus"]');
    const plusBtn  = selector.querySelector('[data-action="plus"]');
    if (!input) return;

    minusBtn && minusBtn.addEventListener('click', function () {
      const val = parseInt(input.value) || 1;
      if (val > 1) input.value = val - 1;
    });
    plusBtn && plusBtn.addEventListener('click', function () {
      const val = parseInt(input.value) || 1;
      input.value = val + 1;
    });
  });

  /* --- Mobile gallery dots --- */
  const gallery       = document.querySelector('.product-gallery');
  const dotsContainer = document.querySelector('.gallery-dots');
  if (gallery && dotsContainer) {
    const items = gallery.querySelectorAll('.gallery-item');
    // Build one dot per image
    items.forEach(function (_, i) {
      const dot = document.createElement('button');
      dot.className = 'gallery-dot' + (i === 0 ? ' active' : '');
      dot.setAttribute('aria-label', 'View image ' + (i + 1));
      dot.addEventListener('click', function () {
        const itemWidth = items[0].offsetWidth + 8; // item width + gap
        gallery.scrollTo({ left: itemWidth * i, behavior: 'smooth' });
      });
      dotsContainer.appendChild(dot);
    });

    // Update active dot as user swipes
    const dots = dotsContainer.querySelectorAll('.gallery-dot');
    gallery.addEventListener('scroll', function () {
      const itemWidth = items[0].offsetWidth + 8;
      const active    = Math.round(gallery.scrollLeft / itemWidth);
      dots.forEach(function (dot, i) {
        dot.classList.toggle('active', i === active);
      });
    }, { passive: true });
  }

  /* --- Ingredients carousel dots (mobile only) --- */
  (function () {
    if (window.innerWidth > 480) return;
    var grid     = document.querySelector('.ingredients-grid');
    var dotsWrap = document.querySelector('.ingredients-dots');
    if (!grid || !dotsWrap) return;

    var cards = grid.querySelectorAll('.ingredient-card');

    cards.forEach(function (_, i) {
      var dot = document.createElement('button');
      dot.className = 'gallery-dot' + (i === 0 ? ' active' : '');
      dot.setAttribute('aria-label', 'View ingredient ' + (i + 1));
      dot.addEventListener('click', function () {
        var cardWidth = cards[0].offsetWidth + 14; // card width + gap
        grid.scrollTo({ left: cardWidth * i, behavior: 'smooth' });
      });
      dotsWrap.appendChild(dot);
    });

    var dots = dotsWrap.querySelectorAll('.gallery-dot');
    grid.addEventListener('scroll', function () {
      var cardWidth = cards[0].offsetWidth + 14;
      var active    = Math.round(grid.scrollLeft / cardWidth);
      dots.forEach(function (dot, i) {
        dot.classList.toggle('active', i === active);
      });
    }, { passive: true });
  })();

  /* --- Benefits carousel dots (mobile ≤768px) --- */
  (function () {
    if (window.innerWidth > 768) return;
    var grid     = document.querySelector('.benefits-grid');
    var dotsWrap = document.querySelector('.benefits-dots');
    if (!grid || !dotsWrap) return;

    var cards = grid.querySelectorAll('.benefit-card');

    cards.forEach(function (_, i) {
      var dot = document.createElement('button');
      dot.className = 'gallery-dot' + (i === 0 ? ' active' : '');
      dot.setAttribute('aria-label', 'View benefit ' + (i + 1));
      dot.addEventListener('click', function () {
        var cardWidth = cards[0].offsetWidth + 16;
        grid.scrollTo({ left: cardWidth * i, behavior: 'smooth' });
      });
      dotsWrap.appendChild(dot);
    });

    var dots = dotsWrap.querySelectorAll('.gallery-dot');
    grid.addEventListener('scroll', function () {
      var cardWidth = cards[0].offsetWidth + 16;
      var active    = Math.round(grid.scrollLeft / cardWidth);
      dots.forEach(function (dot, i) {
        dot.classList.toggle('active', i === active);
      });
    }, { passive: true });
  })();

  /* --- Product gallery lightbox --- */
  const lightbox      = document.getElementById('product-lightbox');
  const lightboxImg   = document.getElementById('lightbox-image');
  const lightboxVideo = document.getElementById('lightbox-video');
  const galleryItems  = Array.from(document.querySelectorAll('.product-gallery .gallery-item[data-src]'));
  let lightboxIndex   = 0;

  function updateNavBtns() {
    const prev = document.querySelector('.lightbox-prev');
    const next = document.querySelector('.lightbox-next');
    if (prev) prev.disabled = lightboxIndex === 0;
    if (next) next.disabled = lightboxIndex === galleryItems.length - 1;
  }

  function showLightboxItem(index) {
    if (!lightbox || !galleryItems.length) return;
    lightboxIndex = Math.max(0, Math.min(index, galleryItems.length - 1));
    const item = galleryItems[lightboxIndex];
    if (lightboxImg) { lightboxImg.src = item.dataset.src; lightboxImg.alt = item.dataset.alt || ''; }
    lightbox.classList.remove('open--video');
    lightbox.classList.add('open');
    document.body.style.overflow = 'hidden';
    updateNavBtns();
  }

  function openLightbox(src, alt, type) {
    if (!lightbox) return;
    if (type === 'video') {
      if (lightboxVideo) { lightboxVideo.src = src; }
      lightbox.classList.add('open', 'open--video');
    } else {
      if (lightboxImg) { lightboxImg.src = src; lightboxImg.alt = alt || ''; }
      lightbox.classList.remove('open--video');
      lightbox.classList.add('open');
    }
    document.body.style.overflow = 'hidden';
  }

  function closeLightbox() {
    if (!lightbox) return;
    lightbox.classList.remove('open', 'open--video');
    document.body.style.overflow = '';
    setTimeout(function () {
      if (lightboxImg) lightboxImg.src = '';
      if (lightboxVideo) { lightboxVideo.pause(); lightboxVideo.src = ''; }
    }, 200);
  }

  // Open gallery at clicked index
  galleryItems.forEach(function (item, index) {
    item.addEventListener('click', function () { showLightboxItem(index); });
    item.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); showLightboxItem(index); }
    });
  });

  if (lightbox) {
    lightbox.querySelector('.lightbox-backdrop').addEventListener('click', closeLightbox);
    lightbox.querySelector('.lightbox-close').addEventListener('click', closeLightbox);
    const prevBtn = lightbox.querySelector('.lightbox-prev');
    const nextBtn = lightbox.querySelector('.lightbox-next');
    if (prevBtn) prevBtn.addEventListener('click', function () { showLightboxItem(lightboxIndex - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { showLightboxItem(lightboxIndex + 1); });
    // Swipe support
    let touchStartX = 0;
    lightbox.addEventListener('touchstart', function (e) { touchStartX = e.touches[0].clientX; }, { passive: true });
    lightbox.addEventListener('touchend', function (e) {
      const dx = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(dx) > 50) { dx < 0 ? showLightboxItem(lightboxIndex + 1) : showLightboxItem(lightboxIndex - 1); }
    });
  }

  // Keyboard nav
  document.addEventListener('keydown', function (e) {
    if (!lightbox || !lightbox.classList.contains('open')) return;
    if (e.key === 'Escape')     closeLightbox();
    if (e.key === 'ArrowLeft')  showLightboxItem(lightboxIndex - 1);
    if (e.key === 'ArrowRight') showLightboxItem(lightboxIndex + 1);
  });

  /* --- Generic accordion (science section) --- */
  document.querySelectorAll('.accordion-trigger').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      const item   = trigger.closest('.accordion-item');
      const isOpen = item.classList.contains('open');
      // Close all siblings
      const parent = item.closest('.accordion');
      if (parent) {
        parent.querySelectorAll('.accordion-item.open').forEach(i => i.classList.remove('open'));
      }
      if (!isOpen) item.classList.add('open');
    });
  });

  /* --- Supplement facts toggle --- */
  document.querySelectorAll('.supp-facts-toggle').forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      const panel = toggle.nextElementSibling;
      if (!panel) return;
      const isOpen = toggle.classList.toggle('open');
      panel.classList.toggle('open', isOpen);
    });
  });

  /* --- Ingredient cards expand/collapse --- */
  document.querySelectorAll('.ingredient-card__expand').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const card  = btn.closest('.ingredient-card');
      const label = btn.querySelector('.expand-label');
      card.classList.toggle('open');
      if (label) {
        label.textContent = card.classList.contains('open') ? 'Show less' : 'Learn more';
      }
    });
  });

  /* --- FAQ accordion --- */
  document.querySelectorAll('.faq-trigger').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      const item   = trigger.closest('.faq-item');
      const isOpen = item.classList.toggle('open');
      trigger.setAttribute('aria-expanded', isOpen);
    });
  });

  /* --- Sticky buy bar --- */
  const stickyBar  = document.getElementById('sticky-buy-bar');
  const heroSection = document.getElementById('product');
  if (stickyBar && heroSection) {
    const stickyObserver = new IntersectionObserver(function (entries) {
      const heroVisible = entries[0].isIntersecting;
      stickyBar.classList.toggle('is-visible', !heroVisible);
      stickyBar.setAttribute('aria-hidden', heroVisible ? 'true' : 'false');
    }, { threshold: 0 });
    stickyObserver.observe(heroSection);

    const stickyForm = document.getElementById('sticky-buy-form');
    if (stickyForm) {
      stickyForm.addEventListener('submit', function (e) {
        e.preventDefault();
        const id           = stickyForm.querySelector('[name="id"]').value;
        const planInput    = stickyForm.querySelector('[name="selling_plan"]');
        const sellingPlan  = planInput ? planInput.value : null;
        if (!id) { window.location.href = '/checkout'; return; }
        const payload = { id: parseInt(id, 10), quantity: 1 };
        if (sellingPlan) payload.selling_plan = parseInt(sellingPlan, 10);
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        })
        .then(function () {
          if (window.fbq) fbq('track', 'AddToCart', {
            content_ids: [id.toString()],
            content_type: 'product_variant',
            currency: 'USD',
            value: 74.99
          });
          window.location.href = '/checkout';
        })
        .catch(function () { window.location.href = '/checkout'; });
      });
    }
  }

  /* --- Cart quantity stepper --- */
  (function () {
    var cartItems = document.querySelector('.cart-items');
    if (!cartItems) return;

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    function updateCart(line, newQty) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: newQty })
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var subtotalEl = document.getElementById('cart-subtotal');
        if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

        if (newQty === 0) {
          var itemEl = cartItems.querySelector('[data-line="' + line + '"]');
          if (itemEl) itemEl.remove();
          if (cart.item_count === 0) location.reload();
        } else {
          var itemEl = cartItems.querySelector('[data-line="' + line + '"]');
          if (itemEl) {
            itemEl.querySelector('.cart-qty__count').textContent = newQty;
            var lineItem = cart.items[line - 1];
            if (lineItem) {
              var priceEl = itemEl.querySelector('[data-line-price]');
              if (priceEl) priceEl.textContent = formatMoney(lineItem.final_line_price);
            }
          }
        }
      })
      .catch(function () { location.reload(); });
    }

    cartItems.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-action]');
      if (!btn) return;
      var item = btn.closest('.cart-item');
      if (!item) return;
      var line = parseInt(item.dataset.line, 10);
      var action = btn.dataset.action;
      var currentQty = parseInt(item.querySelector('.cart-qty__count').textContent, 10);

      if (action === 'increase') updateCart(line, currentQty + 1);
      if (action === 'decrease') updateCart(line, Math.max(0, currentQty - 1));
      if (action === 'remove')   updateCart(line, 0);
    });
  })();

  /* --- Quote ticker: drag to scrub --- */
  (function () {
    var track = document.querySelector('.ticker-track');
    if (!track) return;

    var DURATION = 60000; // ms -- must match CSS animation duration
    var isDragging = false;
    var startX = 0;
    var currentOffset = 0;
    var halfWidth = 0;

    function getTranslateX() {
      var matrix = new DOMMatrixReadOnly(window.getComputedStyle(track).transform);
      return matrix.m41;
    }

    function onDragStart(clientX) {
      halfWidth = track.scrollWidth / 2;
      currentOffset = getTranslateX();
      isDragging = true;
      startX = clientX;
      track.style.animationPlayState = 'paused';
      track.style.transform = 'translateX(' + currentOffset + 'px)';
      track.style.cursor = 'grabbing';
    }

    function onDragMove(clientX) {
      if (!isDragging) return;
      currentOffset += clientX - startX;
      startX = clientX;
      track.style.transform = 'translateX(' + currentOffset + 'px)';
    }

    function onDragEnd() {
      if (!isDragging) return;
      isDragging = false;
      track.style.cursor = '';

      // Normalize offset into the seamless loop range [0, -halfWidth)
      var normalized = currentOffset % (-halfWidth);
      if (normalized > 0) normalized -= halfWidth;

      // Restart animation from the dragged position using a negative delay
      var delay = -(DURATION * Math.abs(normalized) / halfWidth);
      track.style.transform = '';
      track.style.animation = 'ticker-scroll ' + (DURATION / 1000) + 's linear ' + delay + 'ms infinite';
    }

    track.addEventListener('mousedown', function (e) { e.preventDefault(); onDragStart(e.clientX); });
    window.addEventListener('mousemove', function (e) { onDragMove(e.clientX); });
    window.addEventListener('mouseup', onDragEnd);

    track.addEventListener('touchstart', function (e) { onDragStart(e.touches[0].clientX); }, { passive: true });
    track.addEventListener('touchmove', function (e) { if (isDragging) { e.preventDefault(); onDragMove(e.touches[0].clientX); } }, { passive: false });
    track.addEventListener('touchend', onDragEnd);

    track.style.cursor = 'grab';
  })();

  /* --- Testimonials carousel (desktop: 3-up paginated; mobile: CSS scroll) --- */
  (function () {
    var wrap = document.querySelector('.testimonials-carousel-wrap');
    if (!wrap) return;

    var grid    = wrap.querySelector('.testimonials-grid');
    var cards   = grid.querySelectorAll('.testimonial-card');
    var navEl   = document.querySelector('.testimonials-nav');
    var prevBtn = navEl && navEl.querySelector('.testi-prev');
    var nextBtn = navEl && navEl.querySelector('.testi-next');
    var dotsWrap = navEl && navEl.querySelector('.testimonials-dots');

    var PER_PAGE = 3;
    var total    = Math.ceil(cards.length / PER_PAGE);
    var current  = 0;

    function isMobile() { return window.innerWidth <= 768; }

    // Build page dots (desktop only)
    if (dotsWrap) {
      for (var i = 0; i < total; i++) {
        var dot = document.createElement('button');
        dot.className = 'gallery-dot' + (i === 0 ? ' active' : '');
        dot.setAttribute('aria-label', 'Page ' + (i + 1));
        dot.dataset.page = i;
        dotsWrap.appendChild(dot);
      }
      dotsWrap.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-page]');
        if (btn) goTo(parseInt(btn.dataset.page, 10));
      });
    }

    function goTo(page) {
      if (isMobile()) return;
      current = Math.max(0, Math.min(page, total - 1));

      var cardWidth = cards[0].offsetWidth;
      var gap       = parseFloat(window.getComputedStyle(grid).gap) || 24;
      grid.style.transform = 'translateX(-' + (current * PER_PAGE * (cardWidth + gap)) + 'px)';

      if (dotsWrap) {
        dotsWrap.querySelectorAll('[data-page]').forEach(function (d) {
          d.classList.toggle('active', parseInt(d.dataset.page, 10) === current);
        });
      }
      if (prevBtn) prevBtn.disabled = current === 0;
      if (nextBtn) nextBtn.disabled = current >= total - 1;
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });

    goTo(0);
  })();

  /* --- Meta Pixel: InitiateCheckout --- */
  ['subscribe-form', 'onetime-form'].forEach(function (formId) {
    var form = document.getElementById(formId);
    if (form) {
      form.addEventListener('submit', function () {
        if (window.fbq) fbq('track', 'InitiateCheckout');
      });
    }
  });

  /* --- Who Is It For: open accordions by default on desktop --- */
  if (window.innerWidth > 1024) {
    document.querySelectorAll('.wif-faq-list .faq-item').forEach(function (item) {
      item.classList.add('open');
      var trigger = item.querySelector('.faq-trigger');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
    });
  }

  /* --- Who Is It For: force autoplay + unmute toggle --- */
  var wifUnmuteBtn = document.querySelector('.wif-unmute-btn');
  var wifVideo     = document.querySelector('.wif-video');
  if (wifVideo) {
    wifVideo.muted = true;
    var playPromise = wifVideo.play();
    if (playPromise !== undefined) {
      playPromise.catch(function () { /* autoplay blocked by browser -- video stays paused */ });
    }
  }
  if (wifUnmuteBtn && wifVideo) {
    wifUnmuteBtn.addEventListener('click', function () {
      var isMuted = wifVideo.muted;
      wifVideo.muted = !isMuted;
      if (!isMuted) {
        wifUnmuteBtn.querySelector('.wif-unmute-btn__icon--muted').style.display = '';
        wifUnmuteBtn.querySelector('.wif-unmute-btn__icon--sound').style.display = 'none';
        wifUnmuteBtn.querySelector('.wif-unmute-btn__label').textContent = 'Tap to unmute';
      } else {
        wifUnmuteBtn.querySelector('.wif-unmute-btn__icon--muted').style.display = 'none';
        wifUnmuteBtn.querySelector('.wif-unmute-btn__icon--sound').style.display = '';
        wifUnmuteBtn.querySelector('.wif-unmute-btn__label').textContent = 'Mute';
      }
    });
  }

  /* --- Smooth scroll for anchor links --- */
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      const target = document.querySelector(anchor.getAttribute('href'));
      if (!target) return;
      e.preventDefault();
      const offset = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 72;
      const top    = target.getBoundingClientRect().top + window.scrollY - offset - 16;
      window.scrollTo({ top: top, behavior: 'smooth' });
    });
  });

});
